<template>
    <div>
        <Header/>
        <Nav :list="headerList"/>
        <div ref="content">
            <SingleBanner/>
            <div class="page-content">
                <div class="page-content-left">
                    <div class="page-content-left-title">{{ifmExamObj.yjpj.title}}</div>
                    <div class="page-content-left-time">{{ifmExamObj.yjpj.date}}</div>
                    <!-- <div class="page-content-left-content" v-html="ifmExamObj.yjpj.content"></div> -->
                    <div class="page-content-left-content">
                        <div v-for="(item, index) in list" :key="index" class="single">
                            <img :src="item.image">
                            <div class="info">
                                <div class="content" v-html="item.content"></div>
                                <!-- <div class="title">——{{item.title}}</div> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="page-content-right">
                    <RightTab :list="arr"/>
                </div>
            </div>
        </div>
        <Footer/>
    </div>
</template>
<script>
import RightTab from './components/rightTab.vue';
import { mapState } from 'vuex'
export default {
    computed: mapState([
        'ifmExamObj'
    ]),
    components:{
       RightTab,
    },
    data() {
        return {
            headerList:[
                {name:'首页', href:'/'},
                {name:'IFM考试', href:'/ifmExam'},
                {name:'业界评价', href:'/ifmDesc'},
            ],
            arr:[
                {name:'IFM职业资格考试',url:'/qualificationTest'},
                {name:'认证管理制度',url:'/manageSystem'},
                {name:'补考安排',url:'/makeup'},
                {name:'业界评价',url:'/industryEvaluation'},
            ],
            list:[
                {img:'',title:'全国人大常委、全国人大财经委副主任、中国总会计师协会会长、原财政部副部长 张佑才',content:'国际财务管理协会与中国总会计师协会联合认证“国际财务管理师”是一项适应全球经济化发展的人才工程。财'},
                {img:'',title:'全国人大常委、全国人大财经委副主任、中国总会计师协会会长、原财政部副部长 张佑才',content:'国际财务管理协会与中国总会计师协会联合认证“国际财务管理师”是一项适应全球经济化发展的人才工程。财'},
                {img:'',title:'全国人大常委、全国人大财经委副主任、中国总会计师协会会长、原财政部副部长 张佑才',content:'国际财务管理协会与中国总会计师协会联合认证“国际财务管理师”是一项适应全球经济化发展的人才工程。财'},
                {img:'',title:'全国人大常委、全国人大财经委副主任、中国总会计师协会会长、原财政部副部长 张佑才',content:'国际财务管理协会与中国总会计师协会联合认证“国际财务管理师”是一项适应全球经济化发展的人才工程。财'},
            ]
        }
    },
    mounted(){
        this.$http.get('/api/index/getNavNodes',{nodeName:'业界评价'}).then(res => {
            if(res){
                this.list = res;
            }
        })
    },
    methods: {
        
    },
}
</script>
<style lang="scss" scoped>
.single{
    width: 100%;
    margin-bottom: 45px;
    display: flex;
    justify-content: space-between;
    img{
        display: block;
        width: 100px;
        height: 127px;
        box-shadow: 10px 10px 5px #888888;
    }
    .info{
        width:700px;
        padding-right: 40px;
        box-sizing: border-box;
        .content{
            font-size: 14px;
            color: #3B3B3B;
            letter-spacing: 0.4px;
            line-height: 22px;
            font-weight: 400;
        }
        .title{
            font-size: 14px;
            color: #3B3B3B;
            margin-top: 10px;
            letter-spacing: 0.4px;
            line-height: 22px;
            font-weight: 600;
        }
    }
}
</style>
